
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/submissions",
      function () {
        return require("private-next-pages/admin/submissions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/submissions"])
      });
    }
  